import React, { useContext, useEffect, useState } from "react";
import "./Notifications.css";
import { useNavigate } from "react-router-dom";
import Notification_card from "./Notification_card/Notification_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { DeleteNotification, GetAllNotification } from "../../features/notification/Slice";
import { formatNotifDate } from "../../utils/common";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { Context } from "../../utils/context";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";
function Notifications() {
  const { signin } = useContext(Context)

  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Suceesfull");


  const deleteNotification = async (id) => {
    try {

      const res = await dispatch(DeleteNotification(id));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data);
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        await dispatch(GetAllNotification())
      } else if (res.meta?.requestStatus === "rejected") {
        console.error("DeleteNotification rejected:", res.error);
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Delete failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("DeleteNotification failed:", error);
    }

  };


  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notification);

  const fetch = async (page) => {
    await dispatch(GetAllNotification({ page, }));
  };

  useEffect(() => {
    if (signin)
      fetch(1);
  }, [dispatch, signin]);

  const handlePageChange = async (page) => {
    fetch(page)
  };

  return (
    <div className="notification-page-wrapper">

      <Common_white_header headingText={"Notification"} />

      <div className="notification-list">
        {notifications?.data?.length > 0 ?
          notifications?.data?.map((item) => (
            <Notification_card
              key={item?.id}
              id={item?.id}
              title={item?.name}
              date={formatNotifDate(item?.createdAt)}
              message={item?.description}
              onDelete={deleteNotification}
            />
          ))
          :
          <No_data />
        }
        {notifications?.total_pages > 1 &&
          <CustomPagination currentPage={notifications?.current_page}
            totalPages={notifications?.total_pages}
            handlePageChange={handlePageChange} />}
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </div>
  );
}

export default Notifications;